import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { ArrowLeftIcon, TrashIcon } from "@heroicons/react/24/solid";

const ConfirmModal = ({
  onConfirm,
  onCancel,
  open,
  setOpen,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  imageUrl,
  isLoading,
}) => {
  function closeModal() {
    setOpen(false);
  }

  return (
    // See SingleViewModal for why the v1 `<Transition show={open}>` wrapper is
    // deliberately absent: under Headless UI v2 it suppresses `useInertOthers`,
    // leaving the page behind the dialog exposed to assistive technology.
    <Dialog as="div" open={open} onClose={closeModal} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/90 transition duration-300 ease-out data-[closed]:opacity-0 data-[leave]:duration-200 data-[leave]:ease-in"
      />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel
            transition
            className="transform rounded-[16px] text-left align-middle transition-all bg-white relative overflow-hidden duration-300 ease-out data-[closed]:opacity-0 data-[closed]:scale-95 data-[leave]:duration-200 data-[leave]:ease-in"
            style={{
              backdropFilter: "blur(40px)",
              boxShadow:
                "0px 154px 43px 0px rgba(0,0,0,0), 0px 98px 39px 0px rgba(0,0,0,0.02), 0px 55px 33px 0px rgba(0,0,0,0.08), 0px 25px 25px 0px rgba(0,0,0,0.14), 0px 6px 14px 0px rgba(0,0,0,0.16)",
            }}
          >
            {/* Mobile: vertical layout, Desktop: horizontal layout */}
            <div className="flex flex-col sm:flex-row">
              {/* Image preview */}
              {imageUrl && (
                <div className="w-full sm:w-[176px] sm:h-[235px] shrink-0">
                  <img
                    src={imageUrl}
                    alt="Image to delete"
                    className="w-full h-auto sm:h-full object-cover"
                  />
                </div>
              )}

              {/* Content */}
              <div className="flex flex-col justify-between p-6 flex-1">
                {/* Text content */}
                <div className="max-w-[256px]">
                  <h2 className="font-headline font-semibold text-[20px] leading-[1.44] text-black">
                    {title}
                  </h2>
                  <p className="font-headline text-[14px] leading-[1.44] text-black">
                    {message}
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex gap-2 pt-6">
                  <button
                    onClick={onCancel}
                    disabled={isLoading}
                    className="flex-1 flex items-center justify-center gap-[6px] px-6 py-5 rounded-[16px] border border-solid border-black/[0.08] backdrop-blur transition-colors hover:bg-black/[0.04] disabled:opacity-50"
                    style={{ backgroundColor: "rgba(0,0,0,0.01)" }}
                  >
                    <ArrowLeftIcon className="w-4 h-4 text-black" />
                    <span className="font-mono font-bold text-[12px] leading-none text-black uppercase tracking-tight">
                      {cancelButtonText}
                    </span>
                  </button>
                  <button
                    onClick={onConfirm}
                    disabled={isLoading}
                    className="flex-1 flex items-center justify-center gap-[6px] px-6 py-5 rounded-[16px] transition-colors hover:brightness-110 disabled:opacity-50"
                    style={{ backgroundColor: "#f60042" }}
                  >
                    <TrashIcon className="w-4 h-4 text-white" />
                    <span className="font-mono font-bold text-[12px] leading-none text-white uppercase tracking-tight">
                      {confirmButtonText}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmModal;
